import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CallModalComponent } from './components/call-modal/call-modal.component';
import { CallStatusBarComponent } from './components/call-status-bar/call-status-bar.component';

@Component({
  selector: 'app-call',
  standalone: true,
  imports: [CallModalComponent, CallStatusBarComponent],
  templateUrl: './call.component.html',
  styleUrl: './call.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallComponent {}
